export default function EditorialSection({ label, title, children, testid }) {
  return (
    <div className="editorial-section py-16 md:py-20" data-testid={testid}>
      <div className="stage-wide">
        <div className="section-label mb-4">{label}</div>
        {title && (
          <h3 className="font-serif text-3xl md:text-4xl font-light mb-8 leading-[1.1] display-tight">
            {title}
          </h3>
        )}
        <div className="max-w-[62ch]">{children}</div>
      </div>
    </div>
  );
}
